var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadCloudLine = function SvgUploadCloudLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.75 11.875a4.87 4.87 0 0 1 2.298-4.14 6 6 0 0 1 11.904 0 4.875 4.875 0 0 1-2.202 9l-7.5.015a4.9 4.9 0 0 1-4.5-4.875m11.886 3.365a3.374 3.374 0 0 0 1.523-6.231l-.606-.378-.09-.706a4.5 4.5 0 0 0-8.927 0l-.09.706-.604.378a3.375 3.375 0 0 0 1.522 6.231l.13.01h7.012zm-2.886-4.49v3h-1.5v-3H7L10 7l3 3.75z"
  })));
};
export default SvgUploadCloudLine;